import React, { useCallback } from 'react'
import { RoboAdvisorProps } from '../../utils/types'
import { trackEvent } from '../../utils/tracking/mixpanel'
import clickTrack from '../../utils/tracking/adClick'
import { useMatchScreen } from '../../context/MatchScreenContext'
import '../../styles/Advisors/RoboAdvisor.scss'

const nodeEnv = typeof process !== 'undefined' && process.env ? process.env.NODE_ENV : 'production'

const handleCtaClick = (pageKey: string, roboAdvisorName: string, ctaDestination: string) => {
  const eventName = 'robo-advisor-click'
  const eventPayload = {
    page_key: pageKey,
    'robo-advisor': roboAdvisorName
  }
  trackEvent('MatchScreen', eventName, eventPayload)
  if (nodeEnv !== 'production') {
    if (typeof window !== 'undefined') {
      window.open(ctaDestination, '_blank', 'noopener,noreferrer')
    }
  } else {
    clickTrack(ctaDestination, '_blank', eventPayload)
  }
}

const RoboAdvisor = ({ advisor }: RoboAdvisorProps) => {
  const { state: { pageKey } } = useMatchScreen()
  const { imageUrl, network, name, ctaDestination } = advisor
  const { id, founded_in: foundedIn, description_html: descriptionHtml, match_product_type: matchProductType } = network

  const handleClick = useCallback(() => {
    handleCtaClick(pageKey, name, ctaDestination)
  }, [ctaDestination, name, pageKey])

  return (
        <div className="robo_advisor_profile listing"
             data-is-cpm-match={matchProductType === 'CPM' ? 'true' : 'false'}
             data-network-id={id}
        >
            <div className="robo_advisor_profile_logo">
                {imageUrl && imageUrl.trim() !== '' && (
                    <img alt={`${name} logo`} src={imageUrl}/>
                )}
            </div>
            <div className="profile_stats">
                <div className="profile_name">
                    <div className="profile_type">Robo Advisor</div>
                    <div className="profile_robo_name">{name}</div>
                </div>
                <div className="profile_experience">
                    <div className="profile_detail_key">Founded In</div>
                    <div className="profile_detail_value">{foundedIn}</div>
                </div>
            </div>
            {descriptionHtml && (
                <div
                    className="profile_detail_value profile_description"
                    dangerouslySetInnerHTML={{ __html: descriptionHtml }}
                ></div>
            )}
            <div className="profile_cta">
                <span role='button' tabIndex={0} className="profile_cta_button" onClick={handleClick} onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
                  Get Started
                </span>
            </div>
        </div>
  )
}

export default RoboAdvisor
